<template>
  <div class="progress-steps">
    <el-steps
      :active="step"
      direction="vertical"
      finish-status="success"
      :process-status="status === 'failed' ? 'error' : 'process'"
      :space="40"
    >
      <el-step v-for="s in steps" :key="s.label" :title="s.label" />
    </el-steps>
    <div v-if="status === 'failed'" class="progress-steps__error">
      {{ errorMessage || 'Operation failed. Please try again.' }}
    </div>
    <div v-else-if="status !== 'completed'" class="progress-steps__loading">
      <i class="el-icon-loading" /> Processing, please wait...
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressSteps',
  props: {
    steps: { type: Array, required: true },
    status: { type: String, default: null },
    step: { type: Number, default: 0 },
    errorMessage: { type: String, default: null },
  },
};
</script>

<style lang="scss" scoped>

.progress-steps {
  padding: 16px 8px;

  ::v-deep .el-steps {
    .el-step {
      &__head {
        padding-bottom: 8px;
      }
      &__title {
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
      }
      &__main {
        padding-left: 12px;
      }
      &__line {
        top: 28px;
        bottom: -12px;
      }
      &__icon {
        width: 28px;
        height: 28px;
        font-size: 16px;
      }
    }
  }
  &__loading {
    margin-top: 20px;
    color: #409eff;
    font-size: 13px;
    letter-spacing: 0.3px;
  }
  &__error {
    margin-top: 20px;
    color: #f56c6c;
    font-size: 13px;
  }
}
</style>
